
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_13ep8_9",
  "inline-container": "awsui_inline-container_5a145_13ep8_13",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_13ep8_16"
};
  